/**
 * Maps URL ?tab= value to EditarCurso sidebar slug.
 * @param {string | null | undefined} raw
 * @returns {"datos"|"tests"|"docs"|"vista"|"descuentos"}
 */
export function mapSearchParamToEditarCursoTab(raw) {
  if (raw == null || typeof raw !== "string") {
    return "datos";
  }
  const normalized = raw.trim().toLowerCase();
  if (normalized === "test" || normalized === "tests") {
    return "tests";
  }
  if (normalized === "docs" || normalized === "documentos") {
    return "docs";
  }
  if (normalized === "vista" || normalized === "vista-general" || normalized === "general") {
    return "vista";
  }
  if (normalized === "descuentos") {
    return "descuentos";
  }
  return "datos";
}
